import { Component, forwardRef, Input, SimpleChanges } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

@Component({
  selector: 'rr-select-btn',
  standalone: false,

  templateUrl: './select-btn.component.html',
  styleUrl: './select-btn.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectBtnComponent),
      multi: true,
    }
  ]
})
export class SelectBtnComponent {
  @Input() options: Array<any> = [];
  @Input() label: string = '';
  control: FormControl = new FormControl();
  @Input() placeholder: string = '';
  @Input() optionName: string = '';
  @Input() optionValue: string = '';

  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() preselectedValue: any = null;

  selectedName: string = '';
  selectedIcon: string = '';
  showOptions: boolean = false;
  elementWidth: string = 'auto';
  errorClass: string = '';

  constructor() { }

  ngOnInit() {
    this.initializeSelectedOption();
    this.control.valueChanges.subscribe((value) => {
      this.updateSelectedOption(value);
    });
    if (this.preselectedValue) {
      setTimeout(() => {
        this.updateSelectedOption(this.preselectedValue);
      }, 50);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options']) {
      this.initializeSelectedOption();
    }
    if (this.required == true) {
      this.control.setValidators(Validators.required);
    }
  }

  initializeSelectedOption() {
    const selectedOption = this.options?.find(option => option[this.optionValue] === this.control.value);
    if (selectedOption) {
      this.selectedName = selectedOption[this.optionName];
      this.selectedIcon = selectedOption.icon || '';
    }
  }

  updateSelectedOption(value: any) {
    const selectedOption = this.options.find(option => option[this.optionValue] === value);
    if (selectedOption) {
      this.selectedName = selectedOption[this.optionName];
      this.selectedIcon = selectedOption.icon || '';
    }

  }

  selectOption(option: any) {
    if (option === undefined) {
      this.selectedName = '';
      this.selectedIcon = '';
      this.control.setValue(null);
      this.showOptions = false;
      return;
    }

    this.selectedName = option[this.optionName];
    this.selectedIcon = option.icon || '';
    this.showOptions = false;
    this.control.setValue(option[this.optionValue]);
    this.onChange(option[this.optionValue]);
    this.onTouched();
    this.checkValidation();
  }

  toggleOptions(eventTarget: any) {
    if (this.disabled == true) {
      return;
    }
    this.showOptions = !this.showOptions;

    if (this.showOptions) {
      setTimeout(() => {
        const element = (eventTarget as HTMLElement).closest('.mainselect');
        if (element) {
          const width = element.clientWidth;
          this.elementWidth = width + 2 + 'px';
        } else {
          this.elementWidth = 'auto';
        }
      }, 0);
    }
  }

  checkValidation() {
    if (this.required == true) {
      if (this.control.value == null || this.control.value == '') {
        this.errorClass = 'error';
        this.control.setErrors({ required: true });
        this.control.markAsTouched();
      } else {
        this.errorClass = '';
        this.control.setErrors(null);
      }
    }
  }

  writeValue(value: any): void {
    this.control.setValue(value);
  }

  onChange: any = () => { this.checkValidation(); };
  onTouched: any = () => {
    this.checkValidation();
  };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
